import { CircularProgress } from '@mui/material';
import React, { FC, ReactNode, useLayoutEffect, useRef, useState } from 'react';

import '../../../styles/Dimmer.scss';

export type DimmerCover = 'parent' | 'layout';

interface DimmerProps {
  active?: boolean;
  children?: ReactNode;
  cover?: DimmerCover;
}

const DIALOG_SELECTOR = '[role="dialog"], .MuiDialog-root, .MuiModal-root';

const Dimmer: FC<DimmerProps> = ({ active = false, children, cover = 'layout' }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const [inDialog, setInDialog] = useState(false);
  const layoutCover = cover === 'layout' && !inDialog;

  useLayoutEffect(() => {
    if (cover !== 'layout') {
      setInDialog(false);
      return;
    }
    setInDialog(Boolean(rootRef.current?.closest(DIALOG_SELECTOR)));
  }, [active, cover]);

  return (
    <div className={layoutCover ? undefined : 'dimmer-content'} ref={rootRef}>
      {!!active && (
        <div
          className={layoutCover ? 'dimmer-active--layout' : 'dimmer-active'}
          data-testid="dimmer"
          data-active="true"
          data-cover={layoutCover ? 'layout' : 'parent'}>
          <CircularProgress color="secondary" disableShrink />
        </div>
      )}
      {children}
    </div>
  );
};

export default Dimmer;
